"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_i18next_1 = require("react-i18next");
var wrapT_1 = __importDefault(require("../../utils/wrapT"));
exports.default = (function () {
    var _a = react_i18next_1.useTranslation(), t = _a[0], i18n = _a[1];
    return [wrapT_1.default(t), i18n.language];
});
